var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1265 3.17101L4.63824 6.24927C4.46897 6.29463 4.32465 6.40537 4.23702 6.55713C4.1494 6.7089 4.12566 6.88925 4.17101 7.05852L4.85507 9.61147L5.42502 9.45875C6.0607 9.28842 6.76689 9.56504 7.03712 10.1651C7.11732 10.3399 7.15839 10.5302 7.15747 10.7226C7.15655 10.9149 7.11367 11.1048 7.0318 11.2789C6.94994 11.453 6.83107 11.6071 6.6835 11.7305C6.53592 11.8539 6.3632 11.9436 6.17737 11.9934L5.53913 12.1644L6.22319 14.7174C6.26855 14.8866 6.37929 15.0309 6.53105 15.1186C6.68282 15.2062 6.86317 15.2299 7.03244 15.1846L18.5207 12.1063C18.69 12.061 18.8343 11.9502 18.9219 11.7985C19.0095 11.6467 19.0333 11.4663 18.9879 11.2971L18.3039 8.74412L17.6656 8.91513C17.4798 8.96494 17.2854 8.97361 17.0958 8.94052C16.9063 8.90743 16.7263 8.83339 16.5684 8.72355C16.4105 8.61372 16.2784 8.47074 16.1814 8.3046C16.0844 8.13846 16.0249 7.95316 16.0069 7.76162C15.9409 7.10688 16.4142 6.51422 17.0499 6.34389L17.6198 6.19117L16.9357 3.63823C16.8904 3.46896 16.7796 3.32464 16.6279 3.23702C16.4761 3.14939 16.2958 3.12565 16.1265 3.17101ZM11.7963 12.54L10.5198 12.882L10.1778 11.6055L11.4543 11.2635L11.7963 12.54ZM11.1122 9.98704L9.83577 10.3291L9.49374 9.0526L10.7702 8.71057L11.1122 9.98704ZM10.4282 7.4341L9.15171 7.77613L8.80968 6.49966L10.0862 6.15763L10.4282 7.4341Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24:95",
    x: 0.148438,
    y: 0.148438,
    width: 22.8621,
    height: 20.0587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24:95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24:95",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.d918c7bd.svg";
export { ForwardRef as ReactComponent };